'use strict';
angular.module('tachoDownloadDashboard', ['ui.router']).config(function ($stateProvider) {
  $stateProvider
    .state('tachodownloaddashboard',{
      parent: 'betotrack',
      url: '/tachodownloaddashboard',
      ncyBreadcrumb: {
        label: 'Track'
      },
      views: {
        'content@app': {
          templateUrl: 'components/dashboard/tachoDownloadDashboard/tachoDownloadDashboard.tpl.html',
          controller: 'TachoDownloadDashboardCtrl'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Download Status Dashboard';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      }
    });
});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/tachoDownloadDashboard/tachoDownloadDashboard.js